import requests from "../agent";

const Auth = {
  createUsuario: (idOrganizacion, data) => requests.post(`/Auth/CrearUsuario/${idOrganizacion}`, data),
  iniciarSesion: (data) => requests.post("/Auth/IniciarSesion", data),    
  enviaCodigoAutenticacion: () => requests.get("/Auth/EnviaCodigoAutenticacion"),
  validarCodigoAutenticacion: (data) => requests.get(`/Auth/ValidarCodigoAutenticacion?codigo=${data}`)
};

export default Auth;
